var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m109 66.493v33.982a8.6 8.6 0 0 1 -8.59 8.59h-72.82a8.6 8.6 0 0 1 -8.59-8.59v-50.522a8.6 8.6 0 0 1 8.59-8.59h24.82a4.877 4.877 0 0 1 4.34 2.65l.83 1.61 4.95 9.62a4.875 4.875 0 0 0 4.34 2.66h33.54a8.589 8.589 0 0 1 8.59 8.59z",
    fill: "#fecd1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109 52.793v13.7a8.589 8.589 0 0 0 -8.59-8.59h-4.96v-12.28h6.37a7.172 7.172 0 0 1 7.18 7.17z",
    fill: "#fc852d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.45 57.9h-28.58a4.875 4.875 0 0 1 -4.34-2.66l-4.95-9.62-.834-1.617a4.878 4.878 0 0 0 -4.336-2.643h-19.86v-14.391a7.969 7.969 0 0 1 7.969-7.969h46.961a7.969 7.969 0 0 1 7.969 7.969z",
    fill: "#fd3a69"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#123466"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19 75.83a1.75 1.75 0 0 0 1.75-1.75v-4.97a1.75 1.75 0 0 0 -3.5 0v4.97a1.75 1.75 0 0 0 1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.82 43.873h-4.62v-5.423a1.75 1.75 0 0 0 -3.5 0v17.7h-26.83a3.109 3.109 0 0 1 -2.784-1.71l-5.78-11.232a6.611 6.611 0 0 0 -5.9-3.6h-18.106v-12.638a6.227 6.227 0 0 1 6.22-6.22h46.96a6.227 6.227 0 0 1 6.22 6.22v2.37a1.75 1.75 0 1 0 3.5 0v-2.37a9.731 9.731 0 0 0 -9.72-9.72h-46.96a9.731 9.731 0 0 0 -9.72 9.72v12.64h-3.21a10.352 10.352 0 0 0 -10.34 10.34v10.04a1.75 1.75 0 1 0 3.5 0v-10.04a6.848 6.848 0 0 1 6.84-6.84h24.82a3.121 3.121 0 0 1 2.784 1.7l5.776 11.224a6.591 6.591 0 0 0 5.9 3.616h33.54a6.848 6.848 0 0 1 6.84 6.84v33.98a6.848 6.848 0 0 1 -6.84 6.84h-72.82a6.848 6.848 0 0 1 -6.84-6.84v-17.27a1.75 1.75 0 0 0 -3.5 0v17.27a10.352 10.352 0 0 0 10.34 10.34h72.82a10.352 10.352 0 0 0 10.34-10.34v-47.677a8.935 8.935 0 0 0 -8.93-8.92zm-1.41 12.277h-3.21v-8.777h4.62a5.432 5.432 0 0 1 5.43 5.42v5.964a10.286 10.286 0 0 0 -6.84-2.607z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionCategoryIcon);
export default __webpack_public_path__ + "static/media/section_category_icon.2dcd7b7fb9152658595da1f9507b6128.svg";
export { ForwardRef as ReactComponent };